export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14922.83f96729.jpg";